import { render, staticRenderFns } from "./SuccessBox.vue?vue&type=template&id=a3f58148&"
import script from "./SuccessBox.vue?vue&type=script&lang=js&"
export * from "./SuccessBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports